import { blueGrey, green, grey, orange } from '@mui/material/colors'
import { alpha, createTheme as muiCreateTheme } from '@mui/material/styles'

/** Theme is defined in ui-lib/styles.ts */

export const createTheme = ({ textSize }: { textSize?: number } = {}) => {
  const muiTheme = muiCreateTheme({
    cssVariables: {
      cssVarPrefix: 'tuna',
      colorSchemeSelector: 'class',
    },

    colorSchemes: {
      dark: {
        palette: {
          background: {
            default: '#101010',
            paper: '#121212',
          },
          layers: alpha('#222222', 0.7),
          secondary: { main: '#e34f82' },
        },
      },
      light: {
        palette: {
          background: {
            default: '#fff',
            paper: '#fcfcfc',
          },
          layers: alpha('#fafaf8', 0.7),
          secondary: { main: '#e34f82' },
        },
      },
    },
    notes: {
      light: {
        main: blueGrey[700],
        outOfScale: orange[700],
        inScale: grey[800],
        root: green[700],
      },
      dark: {
        main: blueGrey[300],
        outOfScale: orange[300],
        inScale: grey[200],
        root: green[300],
      },
    },

    typography: {
      fontSize: textSize,
      fontFamily: `-apple-system,BlinkMacSystemFont,"Segoe UI","Helvetica Neue",Helvetica,Arial,sans-serif,"Apple Color Emoji","Segoe UI Emoj","Segoe UI Symbol";`,
    },
  })

  muiTheme.typography.caption = {
    ...muiTheme.typography.caption,
  }

  muiTheme.typography.h1 = {
    marginTop: `16px`,
    marginBottom: `8px`,
    fontWeight: 500,

    [muiTheme.breakpoints.down('md')]: {
      fontSize: 32,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 36,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 40,
    },
  }
  muiTheme.typography.h2 = {
    marginTop: `16px`,
    marginBottom: `8px`,
    fontWeight: 500,
    [muiTheme.breakpoints.down('md')]: {
      fontSize: 24,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 28,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 30,
    },
  }
  muiTheme.typography.h3 = {
    marginTop: `16px`,
    marginBottom: `8px`,
    fontWeight: 500,
    [muiTheme.breakpoints.down('md')]: {
      fontSize: 20,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 22,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 24,
    },
  }
  muiTheme.typography.h4 = {
    marginTop: `16px`,
    marginBottom: `8px`,

    fontWeight: 500,
    [muiTheme.breakpoints.down('md')]: {
      fontSize: 18,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 20,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 24,
    },
  }
  muiTheme.typography.h5 = {
    marginTop: `16px`,
    marginBottom: `8px`,

    fontWeight: 500,
    [muiTheme.breakpoints.down('md')]: {
      fontSize: 18,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 20,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 22,
    },
  }
  muiTheme.typography.h6 = {
    marginTop: `8px`,
    marginBottom: `8px`,
    fontWeight: 500,

    [muiTheme.breakpoints.down('md')]: {
      fontSize: 16,
    },
    [muiTheme.breakpoints.up('md')]: {
      fontSize: 18,
    },
    [muiTheme.breakpoints.up('lg')]: {
      fontSize: 20,
    },
  }
  muiTheme.shape = {
    borderRadius: 2,
  }
  return muiTheme
}
